<div mat-dialog-title style="margin:0px;">{{dialogTitle}}</div>
<mat-dialog-content style="margin-top: 15px;">
    <div style="display:flex;"  *ngIf="tempCourseOfStudyGrid.length == 0">
        <div style="display:flex;; padding-left: 30px;">
            <span style="padding-top: 8px;">
                There are no data records to display.
            </span>
        </div>
    </div>
    <div class="flex-content" style="height: 100%;" *ngIf="tempCourseOfStudyGrid.length > 0">
        <div style="overflow:auto;">
          <mat-table style="width:100%;" #table [dataSource]="tylerMatData" multiTemplateDataRows class="mat-elevation-z8">
           
            <ng-container matColumnDef="Checkbtn">
                <mat-header-cell *matHeaderCellDef>
                    <tyl-checkbox id='chkCourseForm' name="chkCourseForm" (change)="checkAllForms()"
                    [(checked)]="allFormCheck">
                </tyl-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <tyl-checkbox (change)="checkBoxClick(element)" [(checked)]="element.Checked">
                    </tyl-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Description">
              <mat-header-cell *matHeaderCellDef>
                <span translate>Description</span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{element.Description}} </mat-cell>
            </ng-container>
           
            <mat-header-row *matHeaderRowDef="columnToDisplay; sticky: true" id="cosHeader">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: columnToDisplay; let i = index;" tabindex="0"
              style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple class="element-row">
            </mat-row>
          </mat-table>
        </div>
      </div>
      </mat-dialog-content>

      <mat-dialog-actions>
        <div class="flex-footer">
            <div class="flex-footer-right">
                <tyl-button id="saveButton" (clickEvent)="saveClick()" image="save.png" label="Save"></tyl-button>
                <tyl-button id="cancelButton" image="cancel.png" label="Cancel" (clickEvent)="closeClick()"></tyl-button>
            </div>
        </div>
      </mat-dialog-actions>
